// src/pages/Documentos.jsx
import { createElement as e, useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { getEmployees, getPosts, getSchedulesRecent, MIN_BISEMANA } from '../data/store';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const DIAS_FULL = ['Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado'];

function getBisemana(offset = 0) {
    const base = new Date(2026, 3, 27);
    const today = new Date();
    const diffDays = Math.floor((today - base) / (1000 * 60 * 60 * 24));
    const currentPeriod = Math.floor(diffDays / 14);
    const targetPeriod = currentPeriod + offset;
    const monday = new Date(base);
    monday.setDate(base.getDate() + targetPeriod * 14);
    return Array.from({ length: 14 }, (_, i) => { const d = new Date(monday); d.setDate(monday.getDate() + i); return d; });
}

function fmt(d) {
    return String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0') + '/' + d.getFullYear();
}
function toISO(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
function normalizeToISO(date) {
    if (!date) return '';
    if (date instanceof Date) return toISO(date);
    if (typeof date === 'string') {
          const s = date.trim();
          if (/^\d{4}-/.test(s)) return s.slice(0, 10);
          if (s.includes('/')) {
                  const parts = s.split('/');
                  if (parts.length === 3 && parts[2].length === 4) {
                            const a = parseInt(parts[0], 10);
                            const b = parseInt(parts[1], 10);
                            const y = parts[2];
                            if (b > 12) return y + '-' + String(a).padStart(2, '0') + '-' + String(b).padStart(2, '0');
                            return y + '-' + String(b).padStart(2, '0') + '-' + String(a).padStart(2, '0');
                  }
          }
    }
    return '';
}
function formatShift12h(shift) {
    if (!shift) return '';
    if (shift.includes('AM') || shift.includes('PM')) return shift.replace('/', ' - ');
    let start = '', end = '';
    if (shift.includes('/')) { [start, end] = shift.split('/'); }
    else if (shift.includes('-')) { [start, end] = shift.split('-'); }
    else return shift;
    const convert = (time) => {
          if (!time) return '';
          let [h, m] = time.split(':');
          h = parseInt(h, 10);
          m = m ? String(m).padStart(2, '0') : '00';
          const ampm = h >= 12 ? 'PM' : 'AM';
          h = h % 12 || 12;
          return h + ':' + m + ' ' + ampm;
    };
    return convert(start) + ' - ' + convert(end);
}
async function loadImageAsBase64(url) {
    const res = await fetch(url); const blob = await res.blob();
    return new Promise((resolve) => { const reader = new FileReader(); reader.onloadend = () => resolve(reader.result); reader.readAsDataURL(blob); });
}
function horaLocalPR(iso) {
    try {
          const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Puerto_Rico', hour: '2-digit', minute: '2-digit', hour12: true }).formatToParts(new Date(iso));
          const map = {}; parts.forEach(p => { map[p.type] = p.value; });
          return (map.hour || '') + ':' + (map.minute || '') + ' ' + (map.dayPeriod || '');
    } catch (e) { return ''; }
}

function fechaISOPR(iso) {
  try {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Puerto_Rico', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(iso));
  } catch (e) { return String(iso || '').slice(0, 10); }
}

export default function Documentos() {
    const { can } = useAuth();
    const [employees, setEmployees] = useState([]);
    const [posts, setPosts] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState('all');
    const [selectedPost, setSelectedPost] = useState('all');
    const [reportType, setReportType] = useState('blank');
    const [semana, setSemana] = useState(0);
    const [buscando, setBuscando] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [docActual, setDocActual] = useState(null);
    const [nombreArchivo, setNombreArchivo] = useState('reporte.pdf');
    const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
        (async () => {
                try {
                          setEmployees(await getEmployees());
                          setPosts(await getPosts());
                          setSchedules(await getSchedulesRecent());
                } catch (err) { console.error('Error cargando datos', err); }
        })();
  }, []);

  const puedeDescargar = can ? can('canDownloadWorkPlans') : true;
    const days = getBisemana(semana);

  const buscar = async () => {
        if (!puedeDescargar || buscando) return;
        setBuscando(true);
        setErrorMsg('');
        try {
                let ponchesReales = [];
                if (reportType === 'real') {
                          const params = new URLSearchParams({ start: toISO(days[0]), end: toISO(days[13]) });
                          const res = await fetch('/api/ponches-range?' + params.toString());
                          const data = await res.json();
                          ponchesReales = data.ponches || [];
                }

          const logoBase64 = await loadImageAsBase64('/logo-ggpc.jpg');
                const doc = new jsPDF('p', 'mm', 'letter');
                let firstPage = true;

          const empSelected = String(selectedEmployee);
                const list = empSelected === 'all' ? employees : employees.filter(emp => String(emp.id) === empSelected);

          for (const emp of list) {
                    const empSchedules = days.flatMap((day) => {
                                const dayISO = toISO(day);
                                const daySchedules = schedules.filter(s => String(s.employee_id || s.employeeId) === String(emp.id) && normalizeToISO(s.date) === dayISO);
                                return daySchedules.map((sched) => {
                                              const postId = sched.post_id || sched.postId;
                                              const post = posts.find(p => String(p.id) === String(postId));
                                              return { date: fmt(day), dateISO: dayISO, day: DIAS_FULL[day.getDay()].toUpperCase(), shift: sched.shift || '', postName: post ? post.name : (sched.post_name || ''), postId };
                                });
                    });

                  const schedulesByPost = {};
                    empSchedules.filter(s => s.shift).forEach(s => {
                                const key = s.postName || 'SIN PUESTO';
                                if (!schedulesByPost[key]) schedulesByPost[key] = [];
                                schedulesByPost[key].push(s);
                    });

                  // Hoja de asistencia App: incluir puestos donde el empleado tiene ponches validos aunque no tenga turno asignado ese periodo
if (reportType === 'real') {
ponchesReales.filter(p => String(p.employee_id) === String(emp.id)).forEach(p => {
if (p.post_id == null || p.post_id === '') return;
const yaExiste = Object.values(schedulesByPost).some(arr => arr.some(s => String(s.postId) === String(p.post_id)));
if (yaExiste) return;
const postP = posts.find(pp => String(pp.id) === String(p.post_id));
const keyP = postP ? postP.name : (p.post_name || ('Puesto ' + p.post_id));
if (schedulesByPost[keyP]) return;
schedulesByPost[keyP] = [{ postId: p.post_id, postName: keyP, dateISO: null, shift: '' }];
});
}

const gruposFiltrados = Object.entries(schedulesByPost).filter(([postName]) => {
                              if (selectedPost === 'all') return true;
                              const post = posts.find(p => p.name === postName);
                              return post && String(post.id) === String(selectedPost);
                  });

                  for (const [postName, scheds] of gruposFiltrados) {
                              if (!firstPage) doc.addPage();
                              firstPage = false;

                      doc.addImage(logoBase64, 'jpeg', 15, 10, 42, 42);
                              doc.setFont('helvetica', 'bold'); doc.setFontSize(15); doc.text('GLOBAL GUARD PROTECTION CORP.', 60, 28);
                              doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.text('P. O. BOX 29596 SAN JUAN, P.R. 00929-0596, Tel.787-276-0400', 60, 35);
                              doc.setDrawColor(245, 197, 24); doc.setLineWidth(0.3); doc.line(60, 37, 200, 37);
                              doc.setFont('helvetica', 'bold'); doc.setFontSize(13);

                      if (reportType === 'blank') {
                                    doc.text('HOJA DE ASISTENCIA', 105, 50, { align: 'center' });
                                    doc.setFontSize(11); doc.setFont('helvetica', 'normal'); doc.setDrawColor(0, 0, 0); doc.setLineWidth(0.3);
                                    doc.text('Nombre: ' + emp.name, 20, 65); doc.line(45, 66, 150, 66);
                                    doc.text('Puesto: ' + postName, 20, 78); doc.line(45, 79, 150, 79);
                                    autoTable(doc, {
                                                    startY: 95,
                                                    head: [[{ content: 'FECHA', rowSpan: 2, styles: { valign: 'middle' } }, { content: 'DIA', rowSpan: 2, styles: { valign: 'middle' } }, { content: 'ENTRADA', rowSpan: 2, styles: { valign: 'middle' } }, { content: 'TOMA DE ALIMENTOS', colSpan: 2, styles: { halign: 'center' } }, { content: 'SALIDA', rowSpan: 2, styles: { valign: 'middle' } }, { content: 'TOTAL DE HORAS', rowSpan: 2, styles: { valign: 'middle' } }], [{ content: 'SALIDA', styles: { halign: 'center' } }, { content: 'ENTRADA', styles: { halign: 'center' } }]],
                                                    body: days.map(day => [fmt(day), DIAS_FULL[day.getDay()].toUpperCase(), '', '', '', '', '']),
                                                    theme: 'grid',
                                                    styles: { fontSize: 9, halign: 'center', valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.3, textColor: [0, 0, 0], minCellHeight: 8 },
                                                    headStyles: { fillColor: false, textColor: [0, 0, 0], fontStyle: 'bold', halign: 'center' },
                                                    columnStyles: { 0: { cellWidth: 25 }, 1: { cellWidth: 33 }, 2: { cellWidth: 26 }, 3: { cellWidth: 20 }, 4: { cellWidth: 20 }, 5: { cellWidth: 26 }, 6: { cellWidth: 21 } },
                                                    margin: { left: 15, right: 15 },
                                    });
                                    const tableBottom = doc.lastAutoTable.finalY;
                                    const boxX = 165, boxW = 21, boxH = 10;
                                    doc.setDrawColor(0, 0, 0); doc.setLineWidth(0.3); doc.rect(boxX, tableBottom, boxW, boxH, 'S');
                                    const finalY = tableBottom + 25;
                                    doc.line(25, finalY, 95, finalY);
                                    doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.text('Firma del empleado', 45, finalY + 5);

                                doc.addPage();
                                    try {
                                                    const wCanvas = document.createElement('canvas');
                                                    wCanvas.width = 500; wCanvas.height = 500;
                                                    const wCtx = wCanvas.getContext('2d');
                                                    const wImg = new Image();
                                                    await new Promise((res) => { wImg.onload = res; wImg.src = logoBase64; });
                                                    wCtx.globalAlpha = 0.30;
                                                    wCtx.drawImage(wImg, 0, 0, 500, 500);
                                                    const watermarkDataUrl = wCanvas.toDataURL('image/png');
                                                    doc.addImage(watermarkDataUrl, 'PNG', 45, 88, 120, 120);
                                    } catch (errW) { /* omitir marca de agua si falla */ }
                                    doc.setFont('helvetica', 'bold'); doc.setFontSize(18); doc.text('Turnos Asignados', 105, 20, { align: 'center' });
                                    doc.setFontSize(10); doc.text(emp.name.toUpperCase(), 25, 32);
                                    doc.setDrawColor(0, 0, 0); doc.setLineWidth(0.3); doc.text('Puesto: ' + postName, 25, 39);
                                    autoTable(doc, {
                                                    startY: 45,
                                                    head: [['Fecha', 'Dia', 'Turno']],
                                                    body: days.map(day => { const dayISO = toISO(day); const found = scheds.find(s => s.dateISO === dayISO); return [fmt(day), DIAS_FULL[day.getDay()], found ? formatShift12h(found.shift) : '']; }),
                                                    theme: 'grid',
                                                    styles: { fontSize: 12, halign: 'center', valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.2, textColor: [0, 0, 0], minCellHeight: 12 },
                                                    headStyles: { fillColor: false, textColor: [0, 0, 0], fontStyle: 'normal', fontSize: 16 },
                                                    columnStyles: { 0: { cellWidth: 55 }, 1: { cellWidth: 55, fontStyle: 'bold', fontSize: 16 }, 2: { cellWidth: 55 } },
                                                    margin: { left: 25, right: 25 },
                                    });
                                    doc.setFontSize(9); doc.text('*Este horario esta sujeto a cambio.', 20, 245);
                      } else {
doc.text('HOJA DE ASISTENCIA', 105, 50, { align: 'center' });
                          doc.setFontSize(11); doc.setFont('helvetica', 'normal'); doc.setDrawColor(0, 0, 0); doc.setLineWidth(0.3);
                          doc.text('Nombre: ' + emp.name, 20, 65); doc.line(45, 66, 150, 66);
                          doc.text('Puesto: ' + postName, 20, 78); doc.line(45, 79, 150, 79);
                          const postIdForGroup = scheds[0] ? scheds[0].postId : null;
                          autoTable(doc, { startY: 95, head: [[{ content: 'FECHA', rowSpan: 2, styles: { valign: 'middle' } }, { content: 'DIA', rowSpan: 2, styles: { valign: 'middle' } }, { content: 'ENTRADA', rowSpan: 2, styles: { valign: 'middle' } }, { content: 'TOMA DE ALIMENTOS', colSpan: 2, styles: { halign: 'center' } }, { content: 'SALIDA', rowSpan: 2, styles: { valign: 'middle' } }, { content: 'TOTAL DE HORAS', rowSpan: 2, styles: { valign: 'middle' } }], [{ content: 'SALIDA', styles: { halign: 'center' } }, { content: 'ENTRADA', styles: { halign: 'center' } }]], body: days.map(day => { const dayISO = toISO(day); const ponchesDelDia = ponchesReales.filter(p => String(p.employee_id) === String(emp.id) && (postIdForGroup ? String(p.post_id) === String(postIdForGroup) : true) && fechaISOPR(p.hora) === dayISO); const entradas = ponchesDelDia.filter(p => p.tipo === 'in').sort((a, b) => new Date(a.hora) - new Date(b.hora)); const salidas = ponchesDelDia.filter(p => p.tipo === 'out').sort((a, b) => new Date(a.hora) - new Date(b.hora)); const entradaReal = entradas[0] ? horaLocalPR(entradas[0].hora) : ''; const salidaReal = salidas.length ? horaLocalPR(salidas[salidas.length - 1].hora) : ''; const mealSalidas = ponchesDelDia.filter(p => p.tipo === 'meal_out').sort((a, b) => new Date(a.hora) - new Date(b.hora)); const mealEntradas = ponchesDelDia.filter(p => p.tipo === 'meal_in').sort((a, b) => new Date(a.hora) - new Date(b.hora)); const mealSalidaReal = mealSalidas[0] ? horaLocalPR(mealSalidas[0].hora) : ''; const mealEntradaReal = mealEntradas.length ? horaLocalPR(mealEntradas[mealEntradas.length - 1].hora) : ''; return [fmt(day), DIAS_FULL[day.getDay()].toUpperCase(), entradaReal, mealSalidaReal, mealEntradaReal, salidaReal, '']; }), theme: 'grid', styles: { fontSize: 9, halign: 'center', valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.3, textColor: [0, 0, 0], minCellHeight: 8 }, headStyles: { fillColor: false, textColor: [0, 0, 0], fontStyle: 'bold', halign: 'center' }, columnStyles: { 0: { cellWidth: 25 }, 1: { cellWidth: 33 }, 2: { cellWidth: 26 }, 3: { cellWidth: 20 }, 4: { cellWidth: 20 }, 5: { cellWidth: 26 }, 6: { cellWidth: 21 } }, margin: { left: 15, right: 15 } });
                          const tableBottom = doc.lastAutoTable.finalY;
                          const boxX = 165, boxW = 21, boxH = 10;
                          doc.setDrawColor(0, 0, 0); doc.setLineWidth(0.3); doc.rect(boxX, tableBottom, boxW, boxH, 'S');
                          const finalY = tableBottom + 25;
                          doc.line(25, finalY, 95, finalY);
                          doc.setFont('helvetica', 'bold'); doc.setFontSize(9); doc.text('Firma del empleado', 45, finalY + 5);
                      }
                  }
          }

          if (firstPage) {
                    doc.setFont('helvetica', 'normal'); doc.setFontSize(12);
                    doc.text('No hay horarios para los filtros seleccionados en esta semana.', 20, 30);
          }

          const blobUrl = doc.output('bloburl');
                setPreviewUrl(blobUrl);
                setDocActual(doc);
                const empLabel = (empSelected === 'all' ? 'Todos' : ((employees.find(emp => String(emp.id) === empSelected) || {}).name || 'empleado')).replace(/[^a-z0-9]/gi, '_');
                setNombreArchivo((reportType === 'real' ? 'Hoja_Asistencia_App_' : 'Horario_') + empLabel + '_' + toISO(days[0]) + '_a_' + toISO(days[13]) + '.pdf');
        } catch (err) {
                console.error(err);
                setErrorMsg('Ocurrio un error generando el PDF. Intenta de nuevo.');
        } finally {
                setBuscando(false);
        }
  };

  const descargar = () => {
        if (docActual) docActual.save(nombreArchivo);
  };

  if (!puedeDescargar) {
        return e('div', { style: { color: '#fff', padding: 24 } }, 'No tienes permiso para ver esta seccion.');
  }

  const filtrosRow = e('div', { style: { display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center', marginBottom: 16 } },
                           e('select', { value: selectedEmployee, onChange: (ev) => setSelectedEmployee(ev.target.value), style: { padding: '8px 12px', background: '#1a1a1a', border: '1px solid #333', borderRadius: 8, color: '#fff' } },
                                   e('option', { value: 'all' }, 'Todos los empleados'),
                                   ...employees.map((emp) => e('option', { key: emp.id, value: String(emp.id) }, emp.name))
                                 ),
                           e('select', { value: selectedPost, onChange: (ev) => setSelectedPost(ev.target.value), style: { padding: '8px 12px', background: '#1a1a1a', border: '1px solid #333', borderRadius: 8, color: '#fff' } },
                                   e('option', { value: 'all' }, 'Todos los puestos'),
                                   ...posts.map((p) => e('option', { key: p.id, value: String(p.id) }, p.name))
                                 ),
                           e('select', { value: reportType, onChange: (ev) => setReportType(ev.target.value), style: { padding: '8px 12px', background: '#1a1a1a', border: '1px solid #333', borderRadius: 8, color: '#fff' } },
                                   e('option', { value: 'blank' }, 'Horario (en blanco para llenar a mano)'),
                                   e('option', { value: 'real' }, 'Hoja de Asistencia App (auto-completada con clock in/out)')
                                 ),
                           e('button', { onClick: () => { setSemana((s) => Math.max(MIN_BISEMANA, s - 1)); setPreviewUrl(null); }, disabled: semana <= MIN_BISEMANA, title: semana <= MIN_BISEMANA ? 'Solo se muestran los ultimos 3 meses' : '', style: { background: '#1a1a1a', border: '1px solid #333', color: '#fff', borderRadius: 8, padding: '8px 16px', cursor: semana <= MIN_BISEMANA ? 'not-allowed' : 'pointer', opacity: semana <= MIN_BISEMANA ? 0.4 : 1 } }, 'Bisemana anterior'),
                           e('span', { style: { fontSize: 13, color: '#ccc' } }, fmt(days[0]) + ' - ' + fmt(days[13])),
                           e('button', { onClick: () => { setSemana((s) => s + 1); setPreviewUrl(null); }, style: { background: '#1a1a1a', border: '1px solid #333', color: '#fff', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' } }, 'Bisemana siguiente'),
                           e('button', { onClick: () => { setSemana(0); setPreviewUrl(null); }, style: { background: '#1a1a1a', border: '1px solid #333', color: '#fff', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' } }, 'Bisemana actual'),
                           e('button', { onClick: buscar, disabled: buscando, style: { background: '#F5C518', border: 'none', color: '#000', borderRadius: 8, padding: '8px 20px', cursor: buscando ? 'default' : 'pointer', fontWeight: 700 } }, buscando ? 'Generando...' : 'Buscar')
                         );

  const previewBlock = previewUrl ? e('div', null,
                                          e('div', { style: { border: '1px solid #333', borderRadius: 8, overflow: 'hidden', marginBottom: 12 } },
                                                  e('iframe', { src: previewUrl, title: 'Vista previa PDF', style: { width: '100%', height: 600, border: 'none', background: '#fff' } })
                                                ),
                                          e('button', { onClick: descargar, style: { background: '#F5C518', border: 'none', color: '#000', borderRadius: 8, padding: '10px 24px', cursor: 'pointer', fontWeight: 700 } }, 'Descargar PDF')
                                        ) : null;

  return e('div', { style: { color: '#fff' } },
               e('h2', { style: { marginBottom: 4 } }, 'Documentos'),
               e('p', { style: { color: '#888', fontSize: 13, marginBottom: 20 } }, 'Genera y descarga hojas de horario y asistencia por empleado, puesto y semana.'),
               filtrosRow,
               errorMsg ? e('p', { style: { color: '#ff6b6b' } }, errorMsg) : null,
               previewBlock
             );
}
